import { Instance, SnapshotOut, types } from 'mobx-state-tree'
import { GameStates } from '@ppwr/poker'
import { withRootStore } from '../../extensions'
import { GameSnapshotModel } from '../../api-store'
// biome-ignore lint/style/useNodejsImportProtocol: <explanation>
import { Buffer } from 'buffer'
import MyFirstGameSteps from './MyFirstGameSteps'
import MyFirstGameStepNames from './MyFirstGameStepNames'

global.Buffer = Buffer

export const MyFirstGame = types
  .model({
    firstGameStage: types.optional(types.number, 0),
    isMyFirstGame: types.optional(types.boolean, false)
  })
  .extend(withRootStore)
  .views((self) => ({
    get stageInternalName() {
      if (!self.firstGameStage) {
        return MyFirstGameStepNames.default
      }
      const step = MyFirstGameSteps[self.firstGameStage]

      if (!step) {
        return MyFirstGameStepNames.default
      }

      return step.internalName ?? MyFirstGameStepNames.default
    }
  }))
  .views((self) => ({}))
  .actions((self) => ({
    setFirstGameSnapshot(stage: number) {
      if (!self.isMyFirstGame) {
        return
      }

      const step = MyFirstGameSteps[stage]

      if (!step?.configureGame) {
        return
      }

      const snapshot = step.configureGame({
        _id: self.rootStore.session.user?._id ?? '',
        name: self.rootStore.session.user?.name ?? ''
      })

      self.rootStore.game.game = GameSnapshotModel.create({
        ...snapshot,
        gameState: {
          //@ts-ignore
          tag: GameStates.Playing.tag,
          description: GameStates.Playing.description
        }
      })
    },
    goToNextFirstGameStep() {
      if (!self.isMyFirstGame) {
        return
      }
      self.firstGameStage++
      this.setFirstGameSnapshot(self.firstGameStage)
    },
    setIsMyFirstGame(isMyFirstGame: boolean) {
      self.isMyFirstGame = isMyFirstGame
    },
    getStageInternalName(): MyFirstGameStepNames {
      return MyFirstGameSteps[self.firstGameStage]?.internalName ?? MyFirstGameStepNames.default
    },
    resetFirstGame() {
      self.isMyFirstGame = false
      self.firstGameStage = 0
      self.rootStore.game.teardown()
    }
  }))

/**
 * The GameModalQueueStore instance.
 */
export type MyFirstGameStore = Instance<typeof MyFirstGame>

/**
 * The data of a GameModalQueueStore.
 */
export type MyFirstGameSnapshot = SnapshotOut<typeof MyFirstGame>
